import { client } from "./utils";
import { formatAppListResponse } from "./utils/helpers";

export interface ICompleteTheOperation {
  clientDbId: number;
  locale: string;
  module: string;
  operationType: string;
  operationCode: string;
  finalizeOption?: number;
  note?: string;
  departmentId?: string;
  ignoreWarnings?: number;
  warningId?: string;
}

export const checkDetails = (params: ICompleteTheOperation) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_FINALIZE_CHECK",
    data: {
      module: params.module,
      operationCode: params.operationCode,
      version: "V3",
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export const completeTheOperation = (params: ICompleteTheOperation) => {
  const query: any = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_FINALIZE_V3",
    data: {
      module: params.module,
      operationType: params.operationType,
      operationCode: params.operationCode,
      note: params.note || "",
    },
  };

  if (params.finalizeOption) query.data.finalizeOption = params.finalizeOption;

  if (params.ignoreWarnings) query.data.ignoreWarnings = params.ignoreWarnings;

  if (params.warningId) query.data.warningId = params.warningId;

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export const runClientsProcedure = (params: ICompleteTheOperation) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_FINALIZE_CLIENT",
    data: {
      module: params.module,
      operationType: params.operationType,
      operationCode: params.operationCode,
      finalizeOption: params.finalizeOption ? params.finalizeOption : 0,
      note: params.note || "",
      departmentId: params.departmentId ? params.departmentId : undefined,
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};
